export const timezones = [
  'Asia/Dubai',
  'Europe/Dublin',
  'Europe/Amsterdam',
  'America/Puerto_Rico',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Phoenix',
  'America/Los_Angeles',
  'America/Anchorage',
  'America/Adak',
  'Asia/Tokyo',
  'Pacific/Honolulu',
]
